<template>
  <div class="shop-dark-wrapper px-4 px-sm-6 px-md-10 d-flex flex-column align-center justify-center" style="min-height: 100vh; padding-bottom: 0">
    <div class="glass-card pa-8 text-center animate-fade-in-up stagger-1" style="max-width: 600px; width: 100%">
      <!-- Logo -->
      <v-img height="50px" class="mb-8" contain src="/img/roodyLogoGreen.png"></v-img>

      <!-- Error Icon Visual -->
      <div class="my-6 d-flex justify-center">
        <div
          class="d-flex align-center justify-center rounded-circle"
          style="width: 80px; height: 80px; background: rgba(239, 83, 80, 0.1); border: 3px solid #ef5350">
          <v-icon size="40" color="#ef5350">mdi-alert-circle-outline</v-icon>
        </div>
      </div>

      <!-- Error Heading -->
      <h2 class="text-h5 font-weight-black white--text mb-4" style="line-height: 1.3">Zahlung fehlgeschlagen</h2>

      <!-- Detailed Message -->
      <p class="grey--text text--lighten-1 mb-6" style="font-size: 0.95rem; line-height: 1.6; text-align: left">
        Keine Sorge, es wurde kein Betrag abgebucht. Bitte überprüfe deine Zahlungsinformationen und versuche es erneut. <br /><br />
        Du wirst in Kürze automatisch zurück zum Warenkorb geleitet, um den Zahlungsvorgang fortzusetzen. Solltest du weitere Unterstützung benötigen,
        stehen wir dir gerne zur Verfügung.
      </p>

      <!-- Back Action Button -->
      <v-card-actions class="justify-center px-0 py-0">
        <v-btn class="premium-btn py-6 px-8" block @click="$router.push('/shop/checkout')">
          <v-icon left>mdi-cart-arrow-right</v-icon>
          Zurück zum Warenkorb
        </v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
export default {
  async created() {
    setTimeout(async () => {
      this.$router.push("/shop/checkout")
    }, 10000)
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

.shop-dark-wrapper {
  --bg-primary: #0b0c10;
  --bg-secondary: #1f2833;
  --bg-dark-accent: #0b0c10;
  --bg-card: rgba(255, 255, 255, 0.02);
  --bg-card-hover: rgba(255, 255, 255, 0.04);
  
  --brand-primary: #00B074;
  --brand-primary-glow: rgba(0, 176, 116, 0.35);
  --brand-gradient: linear-gradient(135deg, #00B074 0%, #008758 100%);
  --brand-gradient-hover: linear-gradient(135deg, #05d08b 0%, #00B074 100%);
  
  --border-color: rgba(255, 255, 255, 0.05);
  --border-color-hover: rgba(0, 176, 116, 0.3);
  --border-color-focus: rgba(0, 176, 116, 0.5);
  
  --text-primary: #ffffff;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;
  
  --font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  
  --shadow-premium: 0 25px 50px -12px rgba(0, 0, 0, 0.7);
  --shadow-glow: 0 0 40px rgba(0, 176, 116, 0.12);
  --shadow-glow-hover: 0 0 50px rgba(0, 176, 116, 0.25);
  --blur-amount: 20px;

  background: radial-gradient(circle at 0% 0%, #102019 0%, #08090c 70%) !important;
  color: var(--text-primary) !important;
  min-height: 100vh;
  font-family: var(--font-family) !important;
  letter-spacing: -0.01em;
}

.glass-card {
  background: var(--bg-card) !important;
  backdrop-filter: blur(var(--blur-amount)) !important;
  -webkit-backdrop-filter: blur(var(--blur-amount)) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 28px !important;
  box-shadow: var(--shadow-premium) !important;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

.glass-card:hover {
  background: var(--bg-card-hover) !important;
  border-color: var(--border-color-hover) !important;
  box-shadow: var(--shadow-premium), var(--shadow-glow-hover) !important;
  transform: translateY(-6px) scale(1.01);
}

::v-deep .premium-btn {
  background: var(--brand-gradient) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.95rem !important;
  letter-spacing: 0.02em !important;
  border-radius: 20px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 176, 116, 0.4), var(--shadow-glow) !important;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
  border: none !important;
  text-transform: none !important;
}

::v-deep .premium-btn:hover {
  background: var(--brand-gradient-hover) !important;
  transform: translateY(-3px) scale(1.02) !important;
  box-shadow: 0 15px 30px -5px rgba(0, 176, 116, 0.55), 0 0 30px rgba(0, 176, 116, 0.3) !important;
}

::v-deep .premium-btn:active {
  transform: translateY(-1px) !important;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  opacity: 0;
  animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.stagger-1 { animation-delay: 0.1s; }

::v-deep .v-btn::before {
  background-color: transparent !important;
}
</style>
